<template>
    <div class="py-16 max-w-[960px] mx-auto">
        <div class="grid grid-cols-2 mobile:grid-cols-1 gap-5 border border-grey-200 rounded-3xl bg-white p-3">
            <article class="p-8 flex flex-col gap-2">
                <div>
                    <img src="/images-new/pricing/liza-premium.svg" alt="">
                </div>
                <div>
                    <h2 class="text-2xl font-bold">Liza Premium</h2>
                </div>
                <country-selector></country-selector>
                
                <div class="flex items-center gap-1.5 mt-10">
                    <span class="text-xl font-semibold">€ {{price}}</span>
                    <span class="text-grey-700"> / {{translate('jaar').toLowerCase()}}</span>
                </div>
                
                <div>
                    <a :disabled="hasPremium" :href="orderLink" class="btn btn-primary btn-lg">{{translate("abonneer_nu")}}</a>
                </div>
            </article>
            
            <article class="grid grid-rows-2 gap-2 relative">
                <div class="bg-grey-100 px-10 py-6 flex items-center text-center justify-center flex-col rounded-lg">
                    <h3 class="text-lg mb-2 font-semibold">{{translate('liza_grid_company_info_title')}}</h3>
                    <p class="text-grey-700">
                        {{translate('liza_grid_company_info_text')}}
                    </p>
                </div>
                <span class="size-10 text-lg rounded-full bg-white absolute flex items-center justify-center left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"><i class="far fa-plus text-grey-700"></i></span>
                <div class="bg-grey-100 px-10 py-6 flex items-center text-center justify-center flex-col rounded-lg">
                    <h3 class="text-lg mb-2 font-semibold">{{translate('liza_grid_monitoring_title')}}</h3>
                    <p class="text-grey-700">
                        {{translate('liza_grid_monitoring_text')}}
                    </p>
                </div>
            </article>
        </div>
        <p class="text-sm mt-6 text-grey-700 italic text-center">
            {{translate('excl_vat_message')}}
        </p>
    </div>
</template>

<script lang="ts">
import {useStore} from "../../../../main-store";
import {useStore as useCheckoutStore} from "../../store";
import {defineComponent} from 'vue';
import {Language} from "../../../../types/dto/Language";
import {ISelectCountry, PackageType} from "../../types";
import CountrySelector from "../country-selector.vue";

const store = useStore();

export default defineComponent({
    name: "pricing-grid",
    components: {CountrySelector},
    props: {
        language: String as () => Language,
        currentAbo: String as () => PackageType | null,
        isLoggedin: Boolean
    },
    data() {
        return {
            store
        }
    },
    computed: {
        selectedCountries(): ISelectCountry[] {
            return useCheckoutStore().selectedCountries;
        },
        price(): number {
            return ((this.selectedCountries.length - 1) * useCheckoutStore().extraCountryPrice) + useCheckoutStore().premiumPrice;
        },
        hasPremium(): boolean {
            return this.isLoggedin && (this.currentAbo == "liza-premium" || this.currentAbo == "premium");
        },
        orderLink(): string {
            const params = new URLSearchParams();

            this.selectedCountries.forEach(country => {
                params.append("country", country.code);
            });

            return `/${this.language}/order/liza-premium?${params.toString()}`;
        }
    }
});
</script>